/* eslint-disable no-constant-condition */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable radix */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import addBook from '../../../redux/bookStore/thunk/addBook';
import updateBook from '../../../redux/bookStore/thunk/updateBook';

function AddBook({ editMode, editInfo }) {
  // useDispatch function to dispatch action to the redux store
  const dispatch = useDispatch();
  // local state management to handle data
  const [id, setId] = useState(-1);
  const [name, setName] = useState('');
  const [author, setAuthor] = useState('');
  const [thumbnail, setThumbnail] = useState('');
  const [price, setPrice] = useState('');
  const [rating, setRating] = useState('');
  const [featured, setFeatured] = useState(false);

  // To show editBook data in the form
  if (editInfo.id !== id) {
    setId(editInfo.id);
    setName(editInfo.name);
    setAuthor(editInfo.author);
    setThumbnail(editInfo.thumbnail);
    setPrice(editInfo.price);
    setRating(editInfo.rating);
    setFeatured(editInfo.featured);
  }

  const addBookHandler = e => {
    e.preventDefault();
    // dispatch action to the thunk
    dispatch(
      addBook({
        name,
        author,
        thumbnail,
        price: Number(price),
        rating: Number(rating),
        featured,
      })
    );
    // refresh the input field
    setName('');
    setAuthor('');
    setThumbnail('');
    setPrice('');
    setRating('');
    setFeatured(false);
  };

  // Dispatch update action to the thunk
  const updateBookHandler = e => {
    e.preventDefault();
    dispatch(
      updateBook(id, {
        name,
        author,
        thumbnail,
        price: Number(price),
        rating: Number(rating),
        featured,
      })
    );
    // refresh the input field
    setName('');
    setAuthor('');
    setThumbnail('');
    setPrice('');
    setRating('');
    setFeatured(false);
    setId(-1);
  };

  return (
    <div>
      <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
        <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
        <form
          className="book-form"
          onSubmit={editMode ? updateBookHandler : addBookHandler}
        >
          <div className="space-y-2">
            <label htmlFor="name">Book Name</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookname"
              name="name"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="category">Author</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookauthor"
              name="author"
              value={author}
              onChange={e => setAuthor(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="image">Image Url</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookthumbnail"
              name="thumbnail"
              value={thumbnail}
              onChange={e => setThumbnail(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="price">Price</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookprice"
                name="price"
                value={price}
                onChange={e => setPrice(e.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="quantity">Rating</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookrating"
                name="rating"
                min="1"
                max="5"
                value={rating}
                onChange={e => setRating(e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-center">
            <input
              id="input-Bookfeatured"
              type="checkbox"
              name="featured"
              className="w-4 h-4"
              checked={featured}
              onChange={e => setFeatured(e.target.checked)}
            />
            <label htmlFor="featured" className="ml-2 text-sm">
              {' '}
              This is a featured book{' '}
            </label>
          </div>

          <button type="submit" className="submit" id="submit">
            {editMode ? 'Update Book' : 'Add Book'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddBook;
